import React from 'react'
import Link from 'gatsby-link'
import { Logo } from '@storaensods/seeds-react'
import '@storaensods/seeds-core/dist/css/styles.css';

class Template extends React.Component {
  render() {
    const { location, children, className } = this.props;
    let customClassName = "";
    if(className !== undefined) {
      customClassName = className;
    }

    return (
      <div className="se-layout">
        <header className="se-header se-header--blue ">
          <div className="se-header-content">
            <div className="se-header-title">
              <a href="/" style={{ lineHeight: 1 }}>
                <Logo size="sm" />
              </a>
              <h1 className="se-header-title-heading">
                SEEDS - Stora Enso Design System
              </h1>
            </div>
            <div></div>
          </div>
        </header>
        <div className={` se-fullheight se-mb-2xl ${customClassName}`}>
          {children}
        </div>
        <footer className="se-footer se-footer--neutral">
          <div className="row se-maxWidth1140 se-fullwidth">
            <div className="se-footer-content col-lg-9">
              <div className="se-footer-text">
                Version 2.0
              </div>
            </div>
            <div className="se-footer-menu se-footer-menu--neutral col-lg-3">
              <div>
                <strong className="se-color-text-light">
                  Built by IT &amp; Digitalisation, <br />Brand &amp; Communications teams
                </strong>
              </div>
            </div>
          </div>
        </footer>
      </div>
    )
  }
}

export default Template
